export default __webpack_public_path__ + "static/media/img-egt-swp@2x.e29016ff.png";